<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <nuxt-link :to="localePath('office-products')">
            {{
            $t("page.products")
            }}
          </nuxt-link>
        </li>

        <li class="is-active">
          <a aria-current="page">{{ $t('form.glass') }}</a>
        </li>
      </ul>
    </nav>
    <div class="columns">
      <div class="column">
        <nuxt-link :to="localePath('office-products-glass-single')" class="box">
          <p class="title is-5">{{ $t("page.glass_single") }}</p>
        </nuxt-link>
      </div>
      <div class="column">
        <nuxt-link :to="localePath('office-products-glass-insulating')" class="box">
          <p class="title is-5">{{ $t("page.glass_insulating") }}</p>
        </nuxt-link>
      </div>
      <div class="column">
        <nuxt-link :to="localePath('office-products-glass-shower')" class="box">
          <p class="title is-5">{{ $t("page.glass_shower") }}</p>
        </nuxt-link>
      </div>
    </div>
    <h1 class="is-size-3 m-b-5">{{$t('form.settings')}}</h1>
    <div class="columns is-multiline">
      <div class="column is-one-third">
        <nuxt-link :to="localePath('office-products-glass-edge-processing')" class="box">
          <p class="title is-5">{{ $t("page.edge_processing") }}</p>
        </nuxt-link>
      </div>
      <div class="column is-one-third">
        <nuxt-link :to="localePath('office-products-glass-hole-drilling')" class="box">
          <p class="title is-5">{{ $t("page.hole_drilling") }}</p>
        </nuxt-link>
      </div>
      <div class="column is-one-third">
        <nuxt-link :to="localePath('office-products-glass-corner-section')" class="box">
          <p class="title is-5">{{ $t("page.corner_section") }}</p>
        </nuxt-link>
      </div>
      <div class="column is-one-third">
        <nuxt-link :to="localePath('office-products-glass-corner-cutout')" class="box">
          <p class="title is-5">{{ $t("page.corner_cutout") }}</p>
        </nuxt-link>
      </div>
      <div class="column is-one-third">
        <nuxt-link :to="localePath('office-products-glass-inner-cutout')" class="box">
          <p class="title is-5">{{ $t("page.inner_cutout") }}</p>
        </nuxt-link>
      </div>
      <div class="column is-one-third">
        <nuxt-link :to="localePath('office-products-glass-digital-printing')" class="box">
          <p class="title is-5">{{ $t("page.digital_printing") }}</p>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  scrollToTop: true
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/glass/index.vue